import React, { useContext, useState } from 'react';
import { Button, Card, Input } from 'antd';
import { ApiContext } from '../api/ApiContextProvider';

function CreatePartitionForm() {
  const { requestCreatePartition } = useContext(ApiContext);
  const [inputValue, setInputValue] = useState('');

  const handleClick = () => {
    requestCreatePartition({
      name: inputValue,
      secured: false,
    });
  };

  return (
    <Card title="Create new partition">
      Name of partition
      <Input
        placeholder="Введите текст"
        value={inputValue}
        onChange={(e) => setInputValue(e.target.value)}
        style={{ marginBottom: 10 }}
      />
      <Button type="primary" onClick={handleClick}>
        create partition
      </Button>
    </Card>
  );
}

export default CreatePartitionForm;
